import type { DropdownOption } from "../Dropdown";

export function getNextEnabledIndex(
  options: DropdownOption[],
  currentIndex: number,
  direction: 1 | -1,
): number {
  const len = options.length;
  if (len === 0) return -1;

  let next = currentIndex;
  for (let i = 0; i < len; i += 1) {
    next = (next + direction + len) % len;
    if (!options[next]?.disabled) {
      return next;
    }
  }

  return -1;
}

export function getInitialHighlightedIndex(
  options: DropdownOption[],
  selectedValue: string | number | undefined,
): number {
  if (selectedValue !== undefined && selectedValue !== "") {
    const selectedIndex = options.findIndex((option) => option.value === selectedValue);
    if (selectedIndex >= 0 && !options[selectedIndex]?.disabled) {
      return selectedIndex;
    }
  }

  return getNextEnabledIndex(options, -1, 1);
}
